import * as React from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import moment from 'moment';
import './staff-registration.scss';
import PlainNavbar from 'components/plainNavbar/plainNavbar';
import { ReactComponent as ProfileTickIcon } from 'assets/icons/profiletick.svg';
import { ReactComponent as ArrowDownIcon } from 'assets/icons/arrowdown.svg';
import { ReactComponent as DocumentTextIcon } from 'assets/icons/documenttext.svg';
import { ReactComponent as AddCircleIcon } from 'assets/icons/add_circle.svg';
import { ReactComponent as PercentageIcon } from 'assets/icons/percentage.svg';
import { ReactComponent as CircleTextIcon } from 'assets/icons/circle-text.svg';
import { ReactComponent as EllipseIcon } from 'assets/icons/ellipse.svg';
import { ReactComponent as InfocircleIcon } from 'assets/icons/infocircle.svg';
import { ReactComponent as CheckIcon } from 'assets/icons/check.svg';
import { ReactComponent as TickCircleIcon } from 'assets/icons/tickcircle.svg';
import { ReactComponent as HelpCircleIcon } from 'assets/icons/help_circle.svg';

import CalendarInput from 'common/calendar-input/calendar-input';
import Select, { MultiValue, SingleValue, components } from 'react-select';
import Toggle from 'common/toggle/toggle';
import Toggle2 from 'common/toggle2/toggle2';
import StaffRegTemplates from 'dummy-data/staff-reg-templates.json';
import Label from 'common/label/label';
import Radio from 'common/radio/radio';
import CheckBox from 'common/checkbox/checkbox';
import { CheckCircle } from 'components/check-circle/check-circle';
import StartEndDate from 'components/staff-registration/start-end-date/start-end-date';
import TimePicker from 'components/staff-registration/time-picker/time-picker';
import Button from 'common/button/button';
import RecurringScheduleTaskCard from 'components/staff-registration/recurring-schedule-task-card/recurring-schedule-task-card';

// Data
import scheduledStaffRegData from 'components/staff-registration/scheduled-staff-reg.json';
import staffData from 'components/staff-registration/staff-data.json';
import WorkingHoursLabel from 'components/staff-registration/working-hours-label/working-hours-label';
import Badge from 'common/badge/badge';
import EmployeeListModal from 'components/staff-registration/employee-list-modal/employee-list-modal';
import ToggleButton from 'screens/workSchedule/toggleButton/toggleButton';
import DateSelector from 'common/date-selector/date-selector';
import CommonModal from 'common/CommonModal';
import { IInvitedEmpWithRegist } from 'types/employee-registration';
import { IAnnual, IPayForm, IPosition, IProbation, ISch, ISchData, ISchItemDetail } from 'types/staff-registration';
import { IOption } from 'types/common';
import {
  addComma,
  formatNumberValueToKoreanTime,
  getChangeToKorean,
  onlyNumberInput,
  scheduleToMinValue,
} from 'constants/utils';
import useAlertConfirmStore from 'zustands/useAlertConfirmStore';
import DateInput from 'screens/scheduleModification/dateInput/DateInput';
import useLoadingStore from 'zustands/useLoadingStore';
import { AxiosResponse } from 'axios';
import useApi from 'hooks/useApi';
import useErrorLog from 'hooks/useErrorLog';
import TimeInput from 'common/time-input/time-input';
import { payTypeOptions, deducTypeOptions, positionOptions, daysOfWeekOptions } from 'constants/dataArr';
import WorkingDetailsCard from '../viewInformation/workingDetailsCard/workingDetailsCard';

const scheduledTemplates = [
  { value: '템플릿명1', label: '템플릿명1' },
  { value: '템플릿명2', label: '템플릿명2' },
  { value: 'SELECT', label: '직접입력' },
];

const StaffRegistration: React.FC = (props) => {
  const location = useLocation();
  const navigate = useNavigate();
  console.log('location?.state', location?.state);
  const empList: IInvitedEmpWithRegist[] = location?.state?.empList ?? [];
  console.log('StaffRegistration empList', empList);
  const { setLoadingState } = useLoadingStore();
  const { setModalState } = useAlertConfirmStore();

  const { webApiNode, webApiPhp } = useApi();
  const { checkErrorLog } = useErrorLog();

  const [employeeListModal, setEmployeeListModal] = React.useState<boolean>(false); // 적용대상 모달 표시여부
  const [showCompleteBtn, setShowCompleteBtn] = React.useState<boolean>(false); // 적용대상 확인버튼 표시여부
  const [currentPage, setCurrentPage] = React.useState<number>(1); // 1: 근로정보 2: 일정정보
  // 급여정보
  const [payForm, setPayForm] = React.useState<IPayForm>({
    appStartDate: new Date(), // 근로정보적용시작월
    startDate: new Date(), // 입사일
    endDate: moment().add(1, 'day').toDate(), // 퇴사일
    endDateUse: false, // 퇴사일 미정 사용 유무
    templates: [], // 근로템플릿
    slectedTemplate: { value: 'SELECT', label: '직접입력' }, // 선택한 템플릿
    selectedPayType: { value: '0', label: '시급' }, // 선택한 급여유형
    defaultPay: '', // 기본급
    hourPay_weekPay_use: false, // 주휴수당 자동 가산 체크 여부
    hourPay_weekPay_type: '1', // 1: 근로기준법 기준 10: 월근무시간
    hourPay_weekPay_time: '', // 월근무시간
    hourPay_restTime_use: false, // 휴게시간 자동 차감 체크 여부
    hourPay_restTime_type: '1', // 1: 근로기준법 기준 0: 월근무시간
    hourPay_restTime_time: '', // 월근무시간
    hourPay_allowance_use: false, // 3대 수당 자동 가산 체크 여부
    monthPay_meal: '', // 월급 - 식대
    monthPay_selfdrive: '', // 월급 - 자가운전
    monthPay_bonus: '', // 월급 - 상여
    monthPay_incentive: '', // 월급 - 성과급
    selectedDeducType: { value: '2', label: '4대보험' },
    deduc_penstion: false, // 국민연금
    deduc_health: false, // 건강보험
    deduc_employeement: false, // 고용보험
    deduc_accident: false, // 산재보험
  });
  // 수습계약
  const [probationForm, setProbationForm] = React.useState<IProbation>({
    use: false,
    endDate: moment().add(1, 'day').toDate(),
    rate: '',
  });
  // 직책/권한
  const [positionForm, setPositionForm] = React.useState<IPosition>({
    selectedPosition: { value: '1', label: '매니저' },
    position_allowMyPay: false,
    position_allowStorePay: false,
    position_allowOtherPayAndSch: false,
    position_allowModifyCommute: false,
    position_allowOtherPush: false,
  });
  // 연차
  const [annualForm, setAnnualForm] = React.useState<IAnnual>({
    annual_totalCount: '',
    annual_useCount: '',
    annual_remindCount: '',
    annual_startYear: new Date(),
  });

  // 일정정보
  const [schForm, setSchForm] = React.useState<ISch>({
    slectedTemplate: { value: 'SELECT', label: '직접입력' }, // 선택한 템플릿
    workType: 'FIXED', // 일정 타입 'FIXED': 고정, '': 자율출퇴근
    workStartDate: new Date(), // 일정 시작일
    workEndDate: moment().add(1, 'day').toDate(), // 일정 종료일
    workEndUse: false, // 일정 종료일 사용 유무
    workDaysOfWeek: [],
    workStartTime: '', // 근무 시작시간
    workEndTime: '', // 근무 종료시간
  });
  const [schList, setSchList] = React.useState<ISchData[]>([]);

  const [existingTemplate, setExistingTemplate] = React.useState<boolean>(false);
  const [currentExistingTemplate, setCurrentExistingTemplate] = React.useState<any>();
  const [scheduleTemplates, setScheduleTemplates] = React.useState<boolean>();

  // 적용대상 모달 표시 토글
  const toggleEmployeeListModal = React.useCallback(() => {
    setEmployeeListModal(!employeeListModal);
    if (employeeListModal) {
      setShowCompleteBtn(false);
    }
  }, [employeeListModal]);

  // 날짜 입력 인풋 핸들
  const handleDateChange = (date: Date, type: string) => {
    // 급여 적용 월
    if (type === 'appStartDate') {
      setPayForm((prev) => ({ ...prev, appStartDate: date }));
    }
    // 입사일
    if (type === 'payForm_start') {
      if (moment(date).isAfter(payForm.endDate)) {
        setPayForm((prev) => ({ ...prev, startDate: date, endDate: moment(date).add(1, 'day').toDate() }));
      } else {
        setPayForm((prev) => ({ ...prev, startDate: date }));
      }
      if (moment(date).isAfter(probationForm.endDate)) {
        setProbationForm((prev) => ({ ...prev, endDate: moment(date).add(1, 'day').toDate() }));
      }
    }
    // 퇴사일
    if (type === 'payForm_end') {
      setPayForm((prev) => ({ ...prev, endDate: date }));
    }
    // 수습종료일
    if (type === 'probationForm_end') {
      setProbationForm((prev) => ({ ...prev, endDate: date }));
    }
    // 일정시작일
    if (type === 'schForm_workStart') {
      if (moment(date).isAfter(schForm.workEndDate)) {
        setSchForm((prev) => ({ ...prev, workStartDate: date, workEndDate: moment(date).add(1, 'day').toDate() }));
      } else {
        setSchForm((prev) => ({ ...prev, workStartDate: date }));
      }
      setSchList([]);
    }
    // 일정종료일
    if (type === 'schForm_workEnd') {
      setSchForm((prev) => ({ ...prev, workEndDate: date }));
      setSchList([]);
    }
    // 연차적용년도
    if (type === 'annual_year') {
      setAnnualForm((prev) => ({ ...prev, annual_startYear: date }));
    }
  };

  // 소득신고 셀렉트 핸들
  const handleDeducTypeChange = (value: SingleValue<IOption>) => {
    if (value) {
      setPayForm((prev) => ({
        ...prev,
        selectedDeducType: value,
        deduc_penstion: value.label === '4대보험' ? true : false,
        deduc_health: value.label === '4대보험' ? true : false,
        deduc_employeement: value.label === '4대보험' ? true : false,
        deduc_accident: value.label === '4대보험' ? true : false,
      }));
    }
  };

  // 셀렉트 핸들
  const handleTypeChange = (value: SingleValue<IOption>, type: string) => {
    if (value) {
      if (type === 'pay') {
        const isNotMonthPay = value.label === '시급' || value.label === '일급';
        setPayForm((prev) => ({
          ...prev,
          selectedPayType: value,
          monthPay_meal: isNotMonthPay ? '' : prev.monthPay_meal,
          monthPay_selfdrive: isNotMonthPay ? '' : prev.monthPay_selfdrive,
          monthPay_bonus: isNotMonthPay ? '' : prev.monthPay_bonus,
          monthPay_incentive: isNotMonthPay ? '' : prev.monthPay_incentive,
        }));
      } else if (type === 'deduc') {
        setPayForm((prev) => ({
          ...prev,
          selectedDeducType: value,
          deduc_penstion: value.label === '4대보험' ? true : false,
          deduc_health: value.label === '4대보험' ? true : false,
          deduc_employeement: value.label === '4대보험' ? true : false,
          deduc_accident: value.label === '4대보험' ? true : false,
        }));
      } else if (type === 'position') {
        setPositionForm((prev) => ({
          ...prev,
          selectedPosition: value,
        }));
      }
    }
  };

  // 금액 입력 인풋 핸들
  const handleNumberValueInput = (e: React.ChangeEvent<HTMLInputElement>) => {
    const { name, value } = e.target;
    setPayForm((prev) => ({ ...prev, [name]: addComma(onlyNumberInput(value.split(',').join(''))) }));
  };

  // 시간 입력 인풋 핸들
  const handleTimeValueInput = (e: React.ChangeEvent<HTMLInputElement>) => {
    const { name, value } = e.target;
    setPayForm((prev) => ({ ...prev, [name]: Number(onlyNumberInput(value)).toString() }));
  };

  // 시급 - 수당 항목 선택 핸들러
  const handleChecks = (value: boolean, name: string) => {
    if (name.includes('sch_')) {
      const key = name.split('sch_')[1];
      setSchForm((prev) => ({
        ...prev,
        [key]: value,
      }));
    } else {
      setPayForm((prev) => ({
        ...prev,
        [name]: value,
      }));
    }
  };
  // 시급 - 수당 항목 계산 방법 체크 핸들러
  const handleChecksType = (value: string, name: string) => {
    setPayForm((prev) => ({
      ...prev,
      [name]: value,
      hourPay_weekPay_time: name === 'hourPay_weekPay_type' ? '0' : prev.hourPay_weekPay_time,
      hourPay_restTime_time: name === 'hourPay_restTime_type' ? '0' : prev.hourPay_restTime_time,
    }));
  };
  // 4대보험 항목 체크박스 핸들러
  const handleCheckBoxInput = (event: React.ChangeEvent<HTMLInputElement>) => {
    const { checked, name } = event.target;
    setPayForm((prev) => ({
      ...prev,
      [name]: checked,
    }));
  };

  // 수습 급여 비율 인풋 핸들
  const handlePercentValueInput = (e: React.ChangeEvent<HTMLInputElement>) => {
    const { name, value } = e.target;
    const numberValue = Number(onlyNumberInput(value));
    setProbationForm((prev) => ({
      ...prev,
      [name]: numberValue > 100 ? '100' : onlyNumberInput(value),
    }));
  };

  // 직책/권한 설정 항목 토글
  const togglePositionItem = (
    name:
      | 'position_allowMyPay'
      | 'position_allowStorePay'
      | 'position_allowOtherPayAndSch'
      | 'position_allowModifyCommute'
      | 'position_allowOtherPush',
  ) => {
    setPositionForm((prev) => ({
      ...prev,
      [name]: !prev[name],
    }));
  };

  // 연차 인풋 입력 핸들
  const handleAnnualValueInput = (e: React.ChangeEvent<HTMLInputElement>) => {
    const { name, value } = e.target;
    setAnnualForm((prev) => ({ ...prev, [name]: onlyNumberInput(value) }));
  };

  // 1단계 직원 정보 데이터 유효성 체크
  const validCheckFirstForm = () => {
    // 급여정보
    if (payForm.defaultPay === '') {
      return setModalState({
        isModalShow: true,
        title: '',
        desc: '급여정보 기본급을 입력해 주세요',
      });
    }
    if (payForm.selectedPayType?.label === '시급') {
      // 주휴수당 자동가산, 월 근무시간 체크 시 시간
      if (payForm.hourPay_weekPay_use && payForm.hourPay_weekPay_type === '0' && payForm.hourPay_weekPay_time === '') {
        return setModalState({
          isModalShow: true,
          title: '주휴수당 자동 가산',
          desc: '월 근무시간을 입력해 주세요',
        });
      }
      // 휴게시간 자동차감, 일 휴게시간 체크 시 시간
      if (
        payForm.hourPay_restTime_use &&
        payForm.hourPay_restTime_type === '0' &&
        payForm.hourPay_restTime_time === ''
      ) {
        return setModalState({
          isModalShow: true,
          title: '휴게시간 자동 차감',
          desc: '일 휴게시간을 입력해 주세요',
        });
      }
    }
    // 수습기간 사용 && 급여지급율 값 체크
    if (probationForm.use && probationForm.rate === '') {
      return setModalState({
        isModalShow: true,
        title: '수습계약',
        desc: '수습 급여지급율을 입력해 주세요',
      });
    }
    const totalAnnual = annualForm.annual_totalCount === '' ? 0 : Number(annualForm.annual_totalCount);
    const useAnnual = annualForm.annual_useCount === '' ? 0 : Number(annualForm.annual_useCount);
    const remindAnnual = annualForm.annual_remindCount === '' ? 0 : Number(annualForm.annual_remindCount);
    if (totalAnnual - useAnnual !== remindAnnual) {
      return setModalState({
        isModalShow: true,
        title: '연차정보',
        desc: '올바른 연차 수를 입력해 주세요\n[총 연차 수 - 사용 연차 = 남은 연차]',
      });
    }
    updateEmpWorkInfo();
  };

  // 2단계 일정정보 데이터 체크
  const validCheckSecondForm = () => {
    // 근무요일 체크
    if (schForm.workType === 'FIXED') {
      if (schForm.workDaysOfWeek.length === 0) {
        return setModalState({
          isModalShow: true,
          title: '일정정보',
          desc: '근무 요일을 선택해 주세요',
        });
      }
      // 근무 시작시간 체크
      if (schForm.workStartTime === '') {
        return setModalState({
          isModalShow: true,
          title: '일정정보',
          desc: '근무 시작시간을 선택해 주세요',
        });
      }
      // 근무 종료시간 체크
      if (schForm.workEndTime === '') {
        return setModalState({
          isModalShow: true,
          title: '일정정보',
          desc: '근무 종료시간을 선택해 주세요',
        });
      }
    }
    return true;
  };

  // 직원정보 1차 저장 요청
  const updateEmpWorkInfo = async () => {
    try {
      const obj = {
        TEMPLATE_FLAG: false, // 탬플릿사용여부
        ET_SEQ: 0, // 탬플릿seq
        START: moment(payForm.startDate).format('YYYY-MM-DD'), // 시작일
        END: payForm.endDateUse ? moment(payForm.endDate).format('YYYY-MM-DD') : null, // 종료일
        PAY_TYPE: payForm.selectedPayType?.value, // 급여유형
        PAY: payForm.defaultPay === '' ? '0' : payForm?.defaultPay?.split(',').join(''), // 급여
        PAY_START: moment(payForm.appStartDate).format('YYYY-MM'), // 적용월
        WEEKEND_ALLOWANCE: payForm.hourPay_weekPay_use ? '1' : '0', // 주휴수당여부
        WeekType: payForm.hourPay_weekPay_type, // 1:근로기준 0: 직접입력
        WeekTime: payForm.hourPay_weekPay_time === '' ? '0' : payForm.hourPay_weekPay_time, // 주휴수당 분
        REST_ALLOWANCE: payForm.hourPay_restTime_use ? '1' : '0', // 휴게시간여부
        RestType: payForm.hourPay_restTime_type, // 1:근로기준 0: 직접입력
        RestTime: payForm.hourPay_restTime_time === '' ? '0' : payForm.hourPay_restTime_time, // 휴게시간
        THREE_ALLOWANCE: payForm.hourPay_allowance_use ? '1' : '0', // 3대수당여부

        insurance: payForm.selectedDeducType?.value, // 2:4대보험 1:프리랜서 0:없음
        pension: payForm.deduc_penstion ? '1' : '0', // 국민연금
        health: payForm.deduc_health ? '1' : '0', // 건강보험
        employment: payForm.deduc_employeement ? '1' : '0', // 고용보험
        accident: payForm.deduc_accident ? '1' : '0', // 산재보험
        MEALS: payForm.monthPay_meal === '' || !payForm.monthPay_meal ? '0' : payForm.monthPay_meal.split(',').join(''), // 식대
        SELF_DRIVING:
          payForm.monthPay_selfdrive === '' || !payForm.monthPay_selfdrive
            ? '0'
            : payForm.monthPay_selfdrive.split(',').join(''), // 자가운전
        BONUS:
          payForm.monthPay_bonus === '' || !payForm.monthPay_bonus ? '0' : payForm.monthPay_bonus.split(',').join(''), // 상여
        INCENTIVE:
          payForm.monthPay_incentive === '' || !payForm.monthPay_incentive
            ? '0'
            : payForm.monthPay_incentive.split(',').join(''), // 인센티브
        probation: probationForm.use ? '1' : '0', // 수습여부
        probationDATE: moment(probationForm.endDate).format('YYYY-MM-DD'), // 수습종료일
        probationPercent: probationForm.rate, // 수습퍼센트
        EMP_SEQ_LIST: empList.map((i) => ({ EMP_SEQ: i.empSeq })), // 직원 인덱스배열
        IS_MANAGER: positionForm.selectedPosition.value, // 매니저
        PAY_SHOW: positionForm.position_allowMyPay ? '1' : '0', // 급여보기
        STOREPAY_SHOW: positionForm.position_allowStorePay ? '1' : '0', // 매장급여보기
        OTHERPAY_SHOW: positionForm.position_allowOtherPayAndSch ? '1' : '0', // 타직원급여보기
        CalendarEdit: positionForm.position_allowModifyCommute ? '1' : '0', // 타직원일정수정
        PUSH: positionForm.position_allowOtherPush ? '1' : '0', // 푸시받기
        Annual: annualForm.annual_totalCount === '' ? '0' : annualForm.annual_totalCount, // 총연차
        USE_Annual: annualForm.annual_useCount === '' ? '0' : annualForm.annual_useCount, // 사용연차
        RemainderAnnual: annualForm.annual_remindCount === '' ? '0' : annualForm.annual_remindCount, // 남은연차
        Annual_START: moment(annualForm.annual_startYear).year(), // 연차적용년
      };

      setLoadingState({ isFetchLoading: true });
      const { data }: AxiosResponse['data'] = await webApiNode('post', `/auth/updateEmpInfo`, obj);
      console.log('/auth/updateEmpInfo_data', data);

      if (data.resultCode === 0) {
        changePage();
      } else {
        throw new Error(data.resultMsg);
      }
    } catch (err) {
      checkErrorLog(err, ' /auth/updateEmpInfo');
    } finally {
      setLoadingState({ isFetchLoading: false });
    }
  };

  // 직원 정보 2차저장(일정정보)
  const updateEmpSchInfo = async () => {
    try {
      const empScheduleArr: {
        EMP_SEQ: number;
        EMP_SCH_SEQ: number;
        JE_SEQ: number;
        DAY: string;
        ATTENDANCE_TIME: string;
        WORK_OFF_TIME: string;
        USE_FLAG: number;
        START: string;
        END: string | null;
      }[] = [];
      empList.map((i) => {
        schList.map((sch) => {
          sch.data.map((j) => {
            empScheduleArr.push({
              EMP_SEQ: i.empSeq,
              EMP_SCH_SEQ: -1,
              JE_SEQ: -1,
              DAY: j.DAY,
              ATTENDANCE_TIME: j.ATTENDANCE_TIME,
              WORK_OFF_TIME: j.WORK_OFF_TIME,
              USE_FLAG: 1,
              START: moment(schForm.workStartDate).format('YYYY-MM-DD'),
              END: schForm.workEndUse ? moment(schForm.workEndDate).format('YYYY-MM-DD') : null,
            });
          });
        });
      });
      const obj = {
        START: moment(schForm.workStartDate).format('YYYY-MM-DD'),
        END_FLAG: schForm.workEndUse ? '1' : '0',
        empSchedules: empScheduleArr,
      };

      setLoadingState({ isFetchLoading: true });
      const { data }: AxiosResponse['data'] = await webApiNode('post', `/auth/updateEmpSchedule`, obj);
      console.log('/auth/updateEmpSchedule', data);
      if (data.resultCode === 0) {
        completeInvite();
      } else {
        throw new Error(data.resultMsg);
      }
    } catch (err) {
      setLoadingState({ isFetchLoading: false });
      checkErrorLog(err, ' /auth/updateEmpSchedule');
    } finally {
    }
  };

  // 근무유형 선택
  const handleSelectWorkingMethod = (method: 'FIXED' | 'AUTONOMOUS') => {
    if (method === 'FIXED') {
      setSchForm((prev) => ({ ...prev, workType: method }));
    } else {
      setSchForm((prev) => ({ ...prev, workType: method }));
    }
  };

  // 근무요일 선택
  const handleWorkDayOfWeek = (newValue: MultiValue<IOption>) => {
    setSchForm((prev) => ({ ...prev, workDaysOfWeek: newValue }));
  };

  // 일정 근무시간 선택
  const handleWorkTime = (e: React.ChangeEvent<HTMLInputElement>, name: string) => {
    const { value } = e.target;
    setSchForm((prev) => ({ ...prev, [name]: value }));
  };

  // 자율출퇴근 설정
  const setWorkType = async () => {
    try {
      setLoadingState({ isFetchLoading: true });
      const emps = empList.map((i) => ({ EMP_SEQ: i.empSeq }));
      const { data }: AxiosResponse['data'] = await webApiNode('post', `/auth/toggleCalendar`, {
        CALENDAR: '1',
        EMP_SEQ_LIST: emps,
      });
      console.log('/auth/toggleCalendar_data', data);

      if (data.resultCode === 0) {
        completeInvite();
      } else {
        throw new Error(data.resultMsg);
      }
    } catch (err) {
      setLoadingState({ isFetchLoading: false });
      checkErrorLog(err, ' /auth/toggleCalendar');
    } finally {
    }
  };

  // 직원 합류완료 요청
  const completeInvite = async () => {
    try {
      setLoadingState({ isFetchLoading: true });
      const emps = empList.map((i) => ({ EMP_SEQ: i.empSeq }));
      const { data }: AxiosResponse['data'] = await webApiNode('post', `/auth/setEmpType`, {
        EMP_SEQ_LIST: emps,
      });
      console.log('/auth/setEmpType_data', data);

      if (data.resultCode === 0) {
        navigate('/employee-registration');
        toggleEmployeeListModal();
        setModalState({
          isModalShow: true,
          title: '초대직원 합류 완료',
          desc: '사업장에 직원이 합류되었습니다. 직원목록에서 확인하실 수 있습니다',
          okBtnText: '직원목록이동',
          okCallback: () => navigate('/list-of-employees'),
        });
      } else {
        throw new Error(data.resultMsg);
      }
    } catch (err) {
      checkErrorLog(err, ' /auth/setEmpType');
    } finally {
      setLoadingState({ isFetchLoading: false });
    }
  };

  const [fixedForm, setFixedForm] = React.useState<any>({
    startDate: '',
    endDate: '',
    daysOfWeek: [],
    startTime: '',
    endTime: '',
    breakTime: '',
  });

  const [optionalForm, setOptionalForm] = React.useState<any>({
    startDate: '',
    endDate: '',
    weeksOfMonth: [],
    daysOfWeek: [],
    startTime: '',
    endTime: '',
    breakTime: '',
  });

  const breakTimeArray = [
    { value: '1', label: '휴식 10분 포함' },
    { value: '2', label: '휴식 20분 포함' },
    { value: '3', label: '휴식 30분 포함' },
    { value: '4', label: '휴식 40분 포함' },
    { value: '5', label: '휴식 50분 포함' },
    { value: '6', label: '휴식 60분 포함' },
  ];

  const [breakTime, setBreakTime] = React.useState<any>('');

  const weeksOfMonth = [
    { value: '1', label: '1주' },
    { value: '2', label: '2주' },
    { value: '3', label: '3주' },
    { value: '4', label: '4주' },
  ];

  const setWeeksOfTheMonth = (data: any) => {
    setOptionalForm((value: any) => ({ ...value, weeksOfMonth: data }));
  };

  // 근로템플릿 선택 시 옵션 변경
  const handleTemplateSelect = (selectedOption: any) => {
    if (selectedOption.value === 'SELECT') {
      setExistingTemplate(false);
    } else {
      setExistingTemplate(true);
      setCurrentExistingTemplate(selectedOption);
    }
  };

  // 선택한 일정 추가
  const addSchListItem = () => {
    if (!validCheckSecondForm()) return false;
    const daysItem: ISchItemDetail[] = schForm.workDaysOfWeek.map((i) => {
      return {
        EMP_SEQ: 0,
        EMP_SCH_SEQ: -1,
        JE_SEQ: -1,
        DAY: i.value,
        ATTENDANCE_TIME: schForm.workStartTime,
        WORK_OFF_TIME: schForm.workEndTime,
        USE_FLAG: '1',
        START: moment(schForm.workStartDate).format('YYYY-MM-DD'),
        END: schForm.workEndUse ? moment(schForm.workEndDate).format('YYYY-MM-DD') : null,
      };
    });
    const formatSchList: ISchData = {
      start: moment(schForm.workStartDate).format('YYYY-MM-DD'),
      end: schForm.workEndUse ? moment(schForm.workEndDate).format('YYYY-MM-DD') : null,
      data: daysItem,
    };
    setSchList([...schList, formatSchList]);
    // 선택했던 일정옵션 초기화
    setSchForm((prev) => ({
      ...prev,
      workDaysOfWeek: [],
      workStartTime: '', // 근무 시작시간
      workEndTime: '', // 근무 종료시간
    }));
  };

  // 추가목록에 있는 일정 삭제
  const removeSchListItem = (idx: number) => {
    const listWithoutIdx = [...schList].filter((i, _i) => _i !== idx);
    setSchList(listWithoutIdx);
  };

  const colourStyles = {
    control: (styles: any, { data, isDisabled, isFocused, isSelected }: any) => ({
      ...styles,
      backgroundColor: 'none',
      border: 'none',
      width: '100%',
      height: '56px',
    }),
    multiValueRemove: (base: any) => ({ ...base, display: 'none' }),
  };

  // 수습계약 사용 토글
  const toggleContract = () => {
    setProbationForm((prev) => ({ ...prev, use: !prev.use }));
  };

  const { Option } = components;
  const IconOption = (props: any) => (
    <Option {...props}>
      {props.data.label !== '직접입력' ? (
        <div>
          <DocumentTextIcon /> {props.data.label}
        </div>
      ) : (
        <div>
          <AddCircleIcon /> {props.data.label}
        </div>
      )}
    </Option>
  );

  const changePage = () => {
    if (currentPage === 1) {
      setCurrentPage(2);
    } else {
      setCurrentPage(1);
    }
  };

  const staffTableHeads = ['이름', '핸드폰'];
  let workTimeOfDay = scheduleToMinValue(schForm.workStartTime, schForm.workEndTime);
  // 추가된 일정의 요일 제거
  const unSelectedDayArr = daysOfWeekOptions.filter((i) => {
    const selected: string[] = [];
    schList.map((j, _j) => {
      j.data.map((k) => {
        if (!selected.includes(k.DAY)) {
          selected.push(k.DAY);
        }
      });
    });
    return !selected.includes(i.value);
  });

  return (
    <>
      <PlainNavbar
        backgroundColor="#f3f4f6"
        customButton={
          <div className="plainNavbarFooter__action">
            <div className="plainNavbarFooter__cancel">
              <Button
                label={currentPage === 1 ? '취소' : '이전'}
                type="type1"
                height={42}
                action={() => {
                  if (currentPage === 1) {
                    navigate(-1);
                  } else {
                    changePage();
                  }
                }}
              />
            </div>
            <div>
              <Button
                label="다음"
                type="type2"
                height={42}
                action={() => {
                  if (empList.length === 0) {
                    navigate('/employee-registration');
                    return setModalState({
                      isModalShow: true,
                      title: '직원초대',
                      desc: `적용대상자가 없습니다.\n직원을 초대해 주세요.\n직원이 회원가입하여 로그인하면 [승인대기중] 목록에 표시되고 합류를 진행할 수 있습니다.`,
                    });
                  } else if (currentPage === 1) {
                    validCheckFirstForm();
                  } else {
                    if (schForm.workType === 'FIXED' && schList.length === 0) {
                      return setModalState({
                        isModalShow: true,
                        title: '직원초대',
                        desc: `추가된 일정이 없습니다.\n근무 시간까지 모두 입력 후 [+추가]를 눌러 일정을 추가해 주세요`,
                      });
                    } else {
                      setEmployeeListModal(true);
                      setShowCompleteBtn(true);
                    }
                  }
                }}
              />
            </div>
          </div>
        }>
        <div className="staff-registration">
          <div className="staff-registration__head">
            <div className="staff-registration__head__left">
              <div className="staff-registration__head__breadcrumb">직원초대 &gt; 합류승인 </div>
              <div className="staff-registration__head__text">
                직원초대{' '}
                <span className="staff-registration__head__text__current">
                  {currentPage}
                  <span className="staff-registration__head__text__total">/2</span>{' '}
                </span>
              </div>
            </div>
            <div className="staff-registration__head__right">
              <div className="staff-registration__head__button" onClick={toggleEmployeeListModal}>
                <ProfileTickIcon />
                <div className="staff-registration__head__input">적용대상 {empList.length}명</div>
              </div>
            </div>
          </div>
          {currentPage === 1 && (
            <div>
              <div className="staff-registration__card">
                <div className="staff-registration__card__left">
                  <div className="staff-registration__payment">
                    <div className="staff-registration__payment__head">급여 정보(필수)</div>
                    <div className="staff-registration__payment__body">
                      <div className="staff-registration__payment__body__add-new-template">
                        <DateSelector
                          onChange={(date) => handleDateChange(date, 'payForm_start')}
                          value={payForm.startDate}
                          label="입사일*"
                          height={56}
                        />
                      </div>
                      <div className="staff-registration__payment__body__add-new-template">
                        <DateSelector
                          onChange={(date) => handleDateChange(date, 'payForm_end')}
                          value={payForm.endDate}
                          label="퇴사일*"
                          height={56}
                          minDate={payForm.startDate}
                          hasDisabled={true}
                          disabled={!payForm.endDateUse}
                          toggleDisable={(value: boolean) => handleChecks(value, 'endDateUse')}
                        />
                      </div>

                      <div className="staff-registration__payment__body__select-template">
                        {/* <div className="staff-registration__payment__body__select-template-head">
                        근로템플릿 선택*
                      </div>
                      <div className="staff-registration__payment__body__select-template-select">
                        <Select
                          className="staff-registration__payment__body__input"
                          components={{
                            IndicatorSeparator: () => null,
                            DropdownIndicator: () => (
                              <div style={{ paddingRight: '15px' }}>
                                <ArrowDownIcon />
                              </div>
                            ),
                            Option: IconOption,
                          }}
                          placeholder="템플릿 선택"
                          styles={colourStyles}
                          value={payForm.slectedTemplate}
                          options={templateOptions}
                          onChange={handleTemplateSelect}
                          isDisabled={true}
                        />

                        <div className="staff-registration__payment__body__text-template">근로템플릿 설정</div>
                      </div> */}
                        <div className="staff-registration__payment__body__add-new-template">
                          <DateSelector
                            onChange={(date) => handleDateChange(date, 'appStartDate')}
                            value={payForm.appStartDate}
                            label="급여 정보 적용 시작월*"
                            height={56}
                            isMonthPicker={true}
                          />
                        </div>
                        {payForm.slectedTemplate?.label === '직접입력' && (
                          <div className="staff-registration__payment__body__add-new-template">
                            <div className="staff-registration__payment__body__label">급여정보*</div>
                            <div className="staff-registration__payment__body__add-new-template-input">
                              <div className="staff-registration__payment__body__add-new-template-input-select">
                                <Select
                                  className="staff-registration__payment__body__input2"
                                  components={{
                                    IndicatorSeparator: () => null,
                                    DropdownIndicator: () => (
                                      <div style={{ paddingRight: '15px' }}>
                                        <ArrowDownIcon />
                                      </div>
                                    ),
                                  }}
                                  placeholder="시급"
                                  styles={colourStyles}
                                  value={payForm.selectedPayType}
                                  options={payTypeOptions}
                                  onChange={(newValue) => handleTypeChange(newValue, 'pay')}
                                />
                              </div>
                              <div className="staff-registration__payment__body__percentage">
                                <div>
                                  <CircleTextIcon className="staff-registration__payment__body__percentage__icon" />
                                </div>
                                <input
                                  className="staff-registration__payment__body__pay-percentage-input"
                                  placeholder="금액 입력"
                                  type="text"
                                  name="defaultPay"
                                  value={payForm.defaultPay}
                                  onChange={handleNumberValueInput}
                                  maxLength={12}
                                />
                              </div>
                            </div>
                            {payForm.selectedPayType?.label === '시급' && (
                              <div className="staff-registration__payment__body__add-new-template">
                                <div>
                                  <div className="staff-registration__payment__body__holiday-allowance">
                                    <CheckCircle
                                      onCheck={(value: boolean) => {
                                        handleChecks(value, 'hourPay_weekPay_use');
                                      }}
                                      value={payForm.hourPay_weekPay_use ?? false}
                                      text="(+) 주휴수당 자동 가산"
                                    />
                                    {payForm.hourPay_weekPay_use && (
                                      <div className="staff-registration__payment__body__holiday-allowance__add-weekly">
                                        <div className="staff-registration__payment__body__holiday-allowance__labour-std-act">
                                          <Radio
                                            isChecked={payForm.hourPay_weekPay_type === '1'}
                                            checked={() => handleChecksType('1', 'hourPay_weekPay_type')}
                                            radioName={'hourPay_weekPay_type'}
                                            text="(자동)근로기준법 기준"
                                          />
                                        </div>
                                        <div className="staff-registration__payment__body__holiday-allowance__labour-std-act">
                                          <Radio
                                            isChecked={payForm.hourPay_weekPay_type === '0'}
                                            checked={() => handleChecksType('0', 'hourPay_weekPay_type')}
                                            radioName={'hourPay_weekPay_type'}
                                            text="(수동)월 근무시간"
                                          />
                                        </div>
                                        {payForm.hourPay_weekPay_type === '0' && (
                                          <div className="staff-registration__payment__body__holiday-allowance__input-container">
                                            <input
                                              type="text"
                                              className="staff-registration__payment__body__holiday-allowance__input"
                                              name="hourPay_weekPay_time"
                                              value={payForm.hourPay_weekPay_time}
                                              onChange={handleTimeValueInput}
                                              maxLength={3}
                                            />
                                            <div className="staff-registration__payment__body__holiday-allowance__input-text">
                                              시간
                                            </div>
                                          </div>
                                        )}
                                      </div>
                                    )}
                                  </div>
                                  <div className="staff-registration__payment__body__holiday-allowance">
                                    <CheckCircle
                                      onCheck={(value: boolean) => {
                                        handleChecks(value, 'hourPay_restTime_use');
                                      }}
                                      value={payForm.hourPay_restTime_use ?? false}
                                      text="(-) 휴게시간 자동 차감"
                                    />
                                    {payForm.hourPay_restTime_use && (
                                      <div className="staff-registration__payment__body__holiday-allowance__add-weekly">
                                        <div className="staff-registration__payment__body__holiday-allowance__labour-std-act">
                                          <Radio
                                            isChecked={payForm.hourPay_restTime_type === '1'}
                                            checked={() => handleChecksType('1', 'hourPay_restTime_type')}
                                            radioName={'hourPay_restTime_type'}
                                            text="(자동)근로기준법 기준"
                                          />
                                        </div>
                                        <div className="staff-registration__payment__body__holiday-allowance__labour-std-act">
                                          <Radio
                                            isChecked={payForm.hourPay_restTime_type === '0'}
                                            checked={() => handleChecksType('0', 'hourPay_restTime_type')}
                                            radioName={'hourPay_restTime_type'}
                                            text="(수동)일 휴게시간"
                                          />
                                        </div>
                                        {payForm.hourPay_restTime_type === '0' && (
                                          <div className="staff-registration__payment__body__holiday-allowance__input-container">
                                            <input
                                              type="text"
                                              className="staff-registration__payment__body__holiday-allowance__input"
                                              name="hourPay_restTime_time"
                                              value={payForm.hourPay_restTime_time}
                                              onChange={handleTimeValueInput}
                                              maxLength={3}
                                            />
                                            <div className="staff-registration__payment__body__holiday-allowance__input-text">
                                              분
                                            </div>
                                          </div>
                                        )}
                                      </div>
                                    )}
                                  </div>
                                  <div className="staff-registration__payment__body__holiday-allowance">
                                    <CheckCircle
                                      onCheck={(value: boolean) => {
                                        handleChecks(value, 'hourPay_allowance_use');
                                      }}
                                      value={payForm.hourPay_allowance_use ?? false}
                                      text="(+) 추가, 야간, 휴일수당 50% 자동 가산"
                                    />
                                  </div>
                                </div>
                              </div>
                            )}
                            {payForm.selectedPayType?.label === '월급' && (
                              <>
                                <div className="whiteSpace" />
                                <div className="staff-registration__contract__body__pay-percentage-input-set">
                                  <div className="staff-registration__contract__body__pay-percentage-input-text">
                                    식대
                                  </div>
                                  <div className="staff-registration__contract__body__percentage">
                                    <div>
                                      <CircleTextIcon className="staff-registration__payment__body__percentage__icon" />
                                    </div>
                                    <input
                                      className="staff-registration__contract__body__pay-percentage-input"
                                      placeholder="금액 입력"
                                      type="text"
                                      name="monthPay_meal"
                                      value={payForm.monthPay_meal}
                                      onChange={handleNumberValueInput}
                                      maxLength={12}
                                    />
                                  </div>
                                </div>
                                <div className="whiteSpace" />
                                <div className="staff-registration__contract__body__pay-percentage-input-set">
                                  <div className="staff-registration__contract__body__pay-percentage-input-text">
                                    자가운전
                                  </div>
                                  <div className="staff-registration__contract__body__percentage">
                                    <div>
                                      <CircleTextIcon className="staff-registration__payment__body__percentage__icon" />
                                    </div>
                                    <input
                                      className="staff-registration__contract__body__pay-percentage-input"
                                      placeholder="금액 입력"
                                      type="text"
                                      name="monthPay_selfdrive"
                                      value={payForm.monthPay_selfdrive}
                                      onChange={handleNumberValueInput}
                                      maxLength={12}
                                    />
                                  </div>
                                </div>
                                <div className="whiteSpace" />
                                <div className="staff-registration__contract__body__pay-percentage-input-set">
                                  <div className="staff-registration__contract__body__pay-percentage-input-text">
                                    상여
                                  </div>
                                  <div className="staff-registration__contract__body__percentage">
                                    <div>
                                      <CircleTextIcon className="staff-registration__payment__body__percentage__icon" />
                                    </div>
                                    <input
                                      className="staff-registration__contract__body__pay-percentage-input"
                                      placeholder="금액 입력"
                                      type="text"
                                      name="monthPay_bonus"
                                      value={payForm.monthPay_bonus}
                                      onChange={handleNumberValueInput}
                                      maxLength={12}
                                    />
                                  </div>
                                </div>
                                <div className="whiteSpace" />
                                <div className="staff-registration__contract__body__pay-percentage-input-set">
                                  <div className="staff-registration__contract__body__pay-percentage-input-text">
                                    성과급
                                  </div>
                                  <div className="staff-registration__contract__body__percentage">
                                    <div>
                                      <CircleTextIcon className="staff-registration__payment__body__percentage__icon" />
                                    </div>
                                    <input
                                      className="staff-registration__contract__body__pay-percentage-input"
                                      placeholder="금액 입력"
                                      type="text"
                                      name="monthPay_incentive"
                                      value={payForm.monthPay_incentive}
                                      onChange={handleNumberValueInput}
                                      maxLength={12}
                                    />
                                  </div>
                                </div>
                              </>
                            )}
                            <div className="staff-registration__payment__body__add-new-template">
                              <div className="staff-registration__payment__body__label">소득신고</div>
                              <div>
                                <Select
                                  className="staff-registration__payment__body__input3"
                                  components={{
                                    IndicatorSeparator: () => null,
                                    DropdownIndicator: () => (
                                      <div style={{ paddingRight: '15px' }}>
                                        <ArrowDownIcon />
                                      </div>
                                    ),
                                  }}
                                  placeholder="4대보험"
                                  styles={colourStyles}
                                  value={payForm.selectedDeducType}
                                  options={deducTypeOptions}
                                  onChange={(newValue) => handleTypeChange(newValue, 'deduc')}
                                />
                              </div>
                              {payForm.selectedDeducType?.label === '4대보험' && (
                                <div className="staff-registration__payment__body__income-report">
                                  <div className="staff-registration__payment__body__income-report__checkbox">
                                    <CheckBox
                                      checked={handleCheckBoxInput}
                                      defaultCheck={payForm.deduc_penstion ?? false}
                                      text="국민연금"
                                      checkBoxname="deduc_penstion"
                                    />
                                  </div>
                                  <div className="staff-registration__payment__body__income-report__checkbox">
                                    <CheckBox
                                      checked={handleCheckBoxInput}
                                      defaultCheck={payForm.deduc_health ?? false}
                                      text="건강보험"
                                      checkBoxname="deduc_health"
                                    />
                                  </div>
                                  <div className="staff-registration__payment__body__income-report__checkbox">
                                    <CheckBox
                                      checked={handleCheckBoxInput}
                                      defaultCheck={payForm.deduc_employeement ?? false}
                                      text="고용보험"
                                      checkBoxname="deduc_employeement"
                                    />
                                  </div>
                                  <div className="staff-registration__payment__body__income-report__checkbox">
                                    <CheckBox
                                      checked={handleCheckBoxInput}
                                      defaultCheck={payForm.deduc_accident ?? false}
                                      text="산재보험"
                                      checkBoxname="deduc_accident"
                                    />
                                  </div>
                                </div>
                              )}
                            </div>
                          </div>
                        )}
                        {existingTemplate && (
                          <div className="staff-registration__payment__body__existing-template">
                            <table>
                              <tr>
                                <td className="staff-registration__payment__body__existing-template__td">급여정보</td>
                                <td className="staff-registration__payment__body__existing-template__text">
                                  <div className="staff-registration__payment__body__existing-template__label">
                                    {currentExistingTemplate.rate === 'HOURLY' && (
                                      <Label text="시급" type="custom" color_type="#ECE1F6" />
                                    )}
                                    {currentExistingTemplate.rate === 'WEEKLY' && (
                                      <Label text="주급" type="custom" color_type="#FDD8C3" />
                                    )}
                                    {currentExistingTemplate.rate === 'MONTHLY' && (
                                      <Label text="월급" type="custom" color_type="#FDE9C3" />
                                    )}
                                  </div>
                                  {currentExistingTemplate.salaryInfo}원
                                </td>
                              </tr>
                              <tr>
                                <td className="staff-registration__payment__body__existing-template__td">주휴수</td>
                                <td className="staff-registration__payment__body__existing-template__text">
                                  {currentExistingTemplate.allowance}
                                </td>
                              </tr>
                              <tr>
                                <td className="staff-registration__payment__body__existing-template__td">소득신고</td>
                                <td className="staff-registration__payment__body__existing-template__text">
                                  {currentExistingTemplate.incomeReport}
                                </td>
                              </tr>
                            </table>
                          </div>
                        )}
                      </div>
                    </div>
                  </div>
                </div>
                <div className="staff-registration__card__right">
                  <div>
                    <div className="staff-registration__right-heads">적용 시작월</div>
                    <div className="staff-registration__right-body">시작월 부터 자동으로 급여가 계산됩니다.</div>
                  </div>
                  <div className="staff-registration__right-top">
                    <div className="staff-registration__right-heads">근로 템플릿이란?</div>
                    <div className="staff-registration__right-body">
                      직원들의 급여 정보를 템플릿으로 저장해두고 한번에 적용시킬 수 있어요
                    </div>
                  </div>
                </div>
              </div>
              <div className="staff-registration__card">
                <div
                  className={
                    probationForm.use
                      ? 'staff-registration__contract__left-enabled'
                      : 'staff-registration__contract__left'
                  }>
                  <div className="staff-registration__payment">
                    <div className="staff-registration__contract__up">
                      <div className="staff-registration__contract__head">수습계약</div>
                      <div className="staff-registration__contract__toggle">
                        <Toggle toggled={probationForm.use} onClick={toggleContract} />
                      </div>
                    </div>
                    {probationForm.use && (
                      <div className="staff-registration__contract__body">
                        <div className="staff-registration__contract__body__pay-percentage">
                          <div className="staff-registration__contract__body__end">
                            <DateSelector
                              onChange={(date) => handleDateChange(date, 'probationForm_end')}
                              value={probationForm.endDate}
                              label="수습계약 종료일*"
                              height={56}
                              placeholder="종료일 선택"
                              minDate={payForm.startDate}
                            />
                          </div>
                        </div>
                        <div className="staff-registration__contract__body__pay-percentage">
                          <div className="staff-registration__contract__body__pay-percentage-head">수습 급여 비율*</div>
                          <div className="staff-registration__contract__body__pay-percentage-input-set">
                            <div className="staff-registration__contract__body__pay-percentage-input-text">
                              급여지급율
                            </div>
                            <div className="staff-registration__contract__body__percentage">
                              <div className="staff-registration__contract__body__percentage">
                                <PercentageIcon className="staff-registration__contract__body__percentage__icon" />
                              </div>
                              <input
                                className="staff-registration__contract__body__pay-percentage-input"
                                placeholder="숫자 입력"
                                type="text"
                                name="rate"
                                value={probationForm.rate}
                                onChange={handlePercentValueInput}
                                max={100}
                                maxLength={3}
                              />
                            </div>
                          </div>
                        </div>
                      </div>
                    )}
                  </div>
                </div>
                {probationForm.use && (
                  <div className="staff-registration__card__right">
                    <div>
                      <div className="staff-registration__right-heads">급여계산</div>
                      <div className="staff-registration__right-body">
                        입력하신 ‘수습계약 시작일'부터 ‘수습계약 종료일’ 까지의 기간 동안 ‘급여지급율’에 따라 일할
                        계산됩니다
                      </div>
                    </div>
                  </div>
                )}
              </div>
              <div className="staff-registration__card">
                <div className="staff-registration__card__left">
                  <div className="staff-registration__permission">
                    <div className="staff-registration__permission__head">직책 / 권한 설정</div>
                    <div className="staff-registration__permission__body">
                      <div className="staff-registration__permission__body__select">
                        <div>직책</div>
                        <Select
                          className="staff-registration__payment__body__input4"
                          components={{
                            IndicatorSeparator: () => null,
                            DropdownIndicator: () => (
                              <div style={{ paddingRight: '15px' }}>
                                <ArrowDownIcon />
                              </div>
                            ),
                          }}
                          placeholder="매니저"
                          styles={colourStyles}
                          value={positionForm.selectedPosition}
                          options={positionOptions}
                          onChange={(newValue) => handleTypeChange(newValue, 'position')}
                        />
                      </div>
                      <div className="staff-registration__permission__body__togglers">
                        <div className="staff-registration__permission__togglers__t1">
                          <div className="staff-registration__permission__togglers__t1__text">본인급여 확인 가능</div>
                          <div className="staff-registration__permission__togglers__t1__toggler">
                            <ToggleButton
                              toggled={positionForm.position_allowMyPay}
                              onClick={() => togglePositionItem('position_allowMyPay')}
                            />
                          </div>
                        </div>
                        {positionForm.selectedPosition.label === '매니저' && (
                          <>
                            <div className="staff-registration__permission__togglers__t1">
                              <div className="staff-registration__permission__togglers__t1__text">
                                사업장 급여 확인 가능
                              </div>
                              <div className="staff-registration__permission__togglers__t1__toggler">
                                <ToggleButton
                                  toggled={positionForm.position_allowStorePay}
                                  onClick={() => togglePositionItem('position_allowStorePay')}
                                />
                              </div>
                            </div>
                            <div className="staff-registration__permission__togglers__t1">
                              <div className="staff-registration__permission__togglers__t1__text">
                                직원 급여 / 일정 확인 및 수정 가능
                              </div>
                              <div className="staff-registration__permission__togglers__t1__toggler">
                                <ToggleButton
                                  toggled={positionForm.position_allowOtherPayAndSch}
                                  onClick={() => togglePositionItem('position_allowOtherPayAndSch')}
                                />
                              </div>
                            </div>
                            <div className="staff-registration__permission__togglers__t1">
                              <div className="staff-registration__permission__togglers__t1__text">
                                출퇴근기록 수정 가능
                              </div>
                              <div className="staff-registration__permission__togglers__t1__toggler">
                                <ToggleButton
                                  toggled={positionForm.position_allowModifyCommute}
                                  onClick={() => togglePositionItem('position_allowModifyCommute')}
                                />
                              </div>
                            </div>
                            <div className="staff-registration__permission__togglers__t1">
                              <div className="staff-registration__permission__togglers__t1__text">
                                타직원 출퇴근 알람 받기
                              </div>
                              <div className="staff-registration__permission__togglers__t1__toggler">
                                <ToggleButton
                                  toggled={positionForm.position_allowOtherPush}
                                  onClick={() => togglePositionItem('position_allowOtherPush')}
                                />
                              </div>
                            </div>
                          </>
                        )}
                      </div>
                    </div>
                  </div>
                </div>
                <div className="staff-registration__card__right">
                  <div>
                    <div className="staff-registration__right-heads">직책</div>
                    <div className="staff-registration__right-body">
                      매니저는 사업주의 권한을 부분적으로 부여받아 사업주의 업무를 대행할 수 있어요
                    </div>
                  </div>
                  <div className="staff-registration__right-top">
                    <div className="staff-registration__right-heads">본인급여 확인</div>
                    <div className="staff-registration__right-body">
                      선택 시, 직원이 급여정보 화면에서 누적급여 등을 확인할 수 있어요
                    </div>
                  </div>
                  {positionForm.selectedPosition.label === '매니저' && (
                    <>
                      <div className="staff-registration__right-top">
                        <div className="staff-registration__right-heads">사업장 급여 확인</div>
                        <div className="staff-registration__right-body">
                          선택 시, 직원이 급여정보 화면에서 누적급여 등을 확인할 수 있어요
                        </div>
                      </div>
                      <div className="staff-registration__right-top">
                        <div className="staff-registration__right-heads">직원 급여/일정 확인 및 수정</div>
                        <div className="staff-registration__right-body">
                          직원의 정보수정(급여, 수당, 공제유형 등) 및 근무일정을 수정할 수 있어요
                        </div>
                      </div>
                      <div className="staff-registration__right-top">
                        <div className="staff-registration__right-heads">출퇴근기록 수정</div>
                        <div className="staff-registration__right-body">출퇴근 기록을 수정할 수 있어요</div>
                      </div>
                      <div className="staff-registration__right-top">
                        <div className="staff-registration__right-heads">타직원 출근 알림</div>
                        <div className="staff-registration__right-body">
                          직원의 출퇴근, 체크리스트 알람을 받아보실 수 있어요
                        </div>
                      </div>
                    </>
                  )}
                </div>
              </div>
              <div className="staff-registration__card">
                <div className="staff-registration__card__left">
                  <div className="staff-registration__payment">
                    <div className="staff-registration__payment__head">연차 정보</div>
                    <div className="staff-registration__payment__body">
                      <div className="staff-registration__payment__body__application-start">
                        <DateSelector
                          onChange={(date) => handleDateChange(date, 'annual_year')}
                          value={annualForm.annual_startYear}
                          label="적용년도"
                          height={56}
                          isYearPicker={true}
                        />
                      </div>

                      <div
                        className="staff-registration__payment__body__select-template"
                        style={{ display: 'flex', justifyContent: 'space-between' }}>
                        <div className="staff-registration__payment__body__add-new-template">
                          <div className="staff-registration__payment__body__label">총 연차</div>
                          <div className="staff-registration__contract__body__pay-percentage-input-set">
                            <div className="staff-registration__contract__body__percentage">
                              <div className="staff-registration__payment__body__percentage__icon">일</div>
                              <input
                                className="staff-registration__contract__body__pay-percentage-input"
                                placeholder="총 연차 수 입력"
                                type="text"
                                name="annual_totalCount"
                                value={annualForm.annual_totalCount}
                                onChange={handleAnnualValueInput}
                                maxLength={2}
                                style={{ borderRadius: 8 }}
                              />
                            </div>
                          </div>
                        </div>
                        <div className="staff-registration__payment__body__add-new-template">
                          <div className="staff-registration__payment__body__label">사용 연차</div>
                          <div className="staff-registration__contract__body__pay-percentage-input-set">
                            <div className="staff-registration__contract__body__percentage">
                              <div className="staff-registration__payment__body__percentage__icon">일</div>
                              <input
                                className="staff-registration__contract__body__pay-percentage-input"
                                placeholder="사용 연차 수 입력"
                                type="text"
                                name="annual_useCount"
                                value={annualForm.annual_useCount}
                                onChange={handleAnnualValueInput}
                                maxLength={2}
                                style={{ borderRadius: 8 }}
                              />
                            </div>
                          </div>
                        </div>
                        <div className="staff-registration__payment__body__add-new-template">
                          <div className="staff-registration__payment__body__label">남은 연차</div>
                          <div className="staff-registration__contract__body__pay-percentage-input-set">
                            <div className="staff-registration__contract__body__percentage">
                              <div className="staff-registration__payment__body__percentage__icon">일</div>
                              <input
                                className="staff-registration__contract__body__pay-percentage-input"
                                placeholder="남은 연차 수 입력"
                                type="text"
                                name="annual_remindCount"
                                value={annualForm.annual_remindCount}
                                onChange={handleAnnualValueInput}
                                maxLength={2}
                                style={{ borderRadius: 8 }}
                              />
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="staff-registration__card__right">
                  <div>
                    <div className="staff-registration__right-heads">적용년도</div>
                    <div className="staff-registration__right-body">해당년도부터 연차가 적용됩니다.</div>
                  </div>
                </div>
              </div>
            </div>
          )}
          {currentPage === 2 && (
            <div>
              <div className="staff-registration__card">
                <div className="staff-registration__card__left">
                  <div className="staff-registration__schedule">
                    <div className="staff-registration__schedule__head">일정정보</div>
                    <div className="staff-registration__schedule__body">
                      <div className="staff-registration__schedule__body__select-template">
                        {/* <div className="staff-registration__schedule__body__select-template-head">일정템플릿 선택</div>
                      <div className="staff-registration__schedule__body__select-template-select">
                        <Select
                          className="staff-registration__schedule__body__input"
                          components={{
                            IndicatorSeparator: () => null,
                            DropdownIndicator: () => (
                              <div style={{ paddingRight: '15px' }}>
                                <ArrowDownIcon />
                              </div>
                            ),
                            Option: IconOption,
                          }}
                          placeholder="템플릿 선택"
                          styles={colourStyles}
                          value={schedule.slectedTemplate}
                          options={scheduledTemplates}
                          onChange={handleCurrentTemplateSelect}
                        />
                        <div className="staff-registration__schedule__body__text-template">일정템플릿 설정</div>
                      </div> */}
                        {schForm.slectedTemplate.label === '직접입력' && (
                          <div className="staff-registration__schedule__extend">
                            <div className="staff-registration__schedule__extend__way-of-work">
                              <div className="staff-registration__schedule__extend__way-of-work__left">
                                <EllipseIcon />
                                <span className="staff-registration__schedule__extend__way-of-work__span">
                                  일하는 방식
                                </span>
                              </div>
                              <div className="staff-registration__schedule__extend__way-of-work__right">
                                <div className="staff-registration__schedule__extend__way-of-work__buttons">
                                  <div
                                    className={
                                      schForm.workType === 'FIXED'
                                        ? 'staff-registration__schedule__extend__way-of-work__fix-selected'
                                        : 'staff-registration__schedule__extend__way-of-work__fix'
                                    }
                                    onClick={() => handleSelectWorkingMethod('FIXED')}>
                                    고정
                                  </div>
                                  {/* <div
                                  className={
                                    workingMethod.optional
                                      ? 'staff-registration__schedule__extend__way-of-work__optional-selected'
                                      : 'staff-registration__schedule__extend__way-of-work__optional'
                                  }
                                  onClick={() => handleSelectWorkingMethod('OPTIONAL')}>
                                  선택적
                                </div> */}
                                  <div
                                    className={
                                      schForm.workType === 'AUTONOMOUS'
                                        ? 'staff-registration__schedule__extend__way-of-work__autonomous-selected'
                                        : 'staff-registration__schedule__extend__way-of-work__autonomous'
                                    }
                                    onClick={() => handleSelectWorkingMethod('AUTONOMOUS')}>
                                    자율출퇴근
                                  </div>
                                </div>
                                <div className="staff-registration__schedule__extend__way-of-work__info-message">
                                  <InfocircleIcon />{' '}
                                  <span className="staff-registration__schedule__extend__way-of-work__info-message__text">
                                    {schForm.workType === 'FIXED' && '출퇴근 시간이 고정되어 있습니다'}
                                    {schForm.workType === 'AUTONOMOUS' &&
                                      '등록된 근무 일정 없이 직원이 출퇴근을 기록합니다'}
                                  </span>
                                </div>
                              </div>
                            </div>

                            {/* Fixed */}
                            {schForm.workType === 'FIXED' && (
                              <div className="fixed-form">
                                <div className="staff-registration__schedule__extend__way-of-work">
                                  <div className="staff-registration__schedule__extend__way-of-work__left">
                                    <EllipseIcon />
                                    <span className="staff-registration__schedule__extend__way-of-work__span">
                                      반복기간(시작-종료)
                                    </span>
                                  </div>
                                  <div style={{ display: 'flex', width: '75%', justifyContent: 'space-between' }}>
                                    <div style={{ flex: 0.4 }}>
                                      <DateSelector
                                        onChange={(date) => handleDateChange(date, 'schForm_workStart')}
                                        value={schForm.workStartDate}
                                        height={56}
                                      />
                                    </div>
                                    <div style={{ flex: 0.58 }}>
                                      <DateSelector
                                        onChange={(date) => handleDateChange(date, 'schForm_workEnd')}
                                        value={schForm.workEndDate}
                                        height={56}
                                        minDate={schForm.workStartDate}
                                        hasDisabled={true}
                                        disabled={!schForm.workEndUse}
                                        toggleDisable={(value: boolean) => handleChecks(value, 'sch_workEndUse')}
                                      />
                                    </div>
                                  </div>
                                </div>

                                <div className="staff-registration__schedule__extend__way-of-work">
                                  <div className="staff-registration__schedule__extend__way-of-work__left">
                                    <EllipseIcon />
                                    <span className="staff-registration__schedule__extend__way-of-work__span">
                                      근무 요일
                                    </span>
                                  </div>
                                  <div className="staff-registration__schedule__extend__way-of-work__right">
                                    <Select
                                      className="staff-registration__schedule__body__input4"
                                      name="set-working-days"
                                      components={{
                                        IndicatorSeparator: () => null,
                                        DropdownIndicator: () => (
                                          <div style={{ paddingRight: '15px' }}>
                                            <ArrowDownIcon />
                                          </div>
                                        ),
                                        SingleValue: () => (
                                          <div style={{ paddingRight: '15px' }}>
                                            <ArrowDownIcon />
                                          </div>
                                        ),
                                      }}
                                      placeholder="근무요일 선택"
                                      styles={colourStyles}
                                      options={unSelectedDayArr}
                                      value={schForm.workDaysOfWeek}
                                      onChange={handleWorkDayOfWeek}
                                      isMulti
                                      hideSelectedOptions={false}
                                      isClearable={false}
                                    />
                                  </div>
                                </div>

                                <div className="staff-registration__schedule__extend__way-of-work">
                                  <div className="staff-registration__schedule__extend__way-of-work__left">
                                    <EllipseIcon />
                                    <span className="staff-registration__schedule__extend__way-of-work__span">
                                      근무 시간(시작-종료)
                                    </span>
                                  </div>
                                  <div className="staff-registration__schedule__extend__way-of-work__right">
                                    <div className="staff-registration__schedule__extend__way-of-work__time">
                                      {/* <TimePicker setData={setWorkingTime} /> */}
                                      <div style={{ display: 'flex', width: '100%', justifyContent: 'space-between' }}>
                                        <div style={{ flex: 0.49 }}>
                                          <TimeInput
                                            value={schForm.workStartTime}
                                            onChange={(event: React.ChangeEvent<HTMLInputElement>) =>
                                              handleWorkTime(event, 'workStartTime')
                                            }
                                            iconSide="RIGHT"
                                          />
                                        </div>
                                        <div style={{ flex: 0.49 }}>
                                          <TimeInput
                                            value={schForm.workEndTime}
                                            onChange={(event: React.ChangeEvent<HTMLInputElement>) =>
                                              handleWorkTime(event, 'workEndTime')
                                            }
                                            iconSide="RIGHT"
                                          />
                                        </div>
                                      </div>
                                      {/* <div className="staff-registration__schedule__extend__way-of-work__rest-include">
                                      <Select
                                        className="staff-registration__schedule__body__input4"
                                        components={{
                                          IndicatorSeparator: () => null,
                                          DropdownIndicator: () => (
                                            <div
                                              style={{
                                                paddingRight: '15px',
                                              }}>
                                              <ArrowDownIcon />
                                            </div>
                                          ),
                                        }}
                                        placeholder="템플릿 선택"
                                        styles={colourStyles}
                                        options={breakTimeArray}
                                        // onChange={selectBreakTime}
                                      />
                                    </div> */}
                                    </div>
                                  </div>
                                </div>

                                <div className="staff-registration__list">
                                  <div className="staff-registration__list__plus">
                                    <div className="staff-registration__list__plus__button" onClick={addSchListItem}>
                                      +추가
                                    </div>
                                  </div>
                                </div>

                                {/* {schForm.workDaysOfWeek.length > 0 &&
                                  schForm.workStartTime !== '' &&
                                  schForm.workEndTime !== '' && (
                                    <>
                                      <div className="staff-registration__schedule__extend__way-of-work">
                                        <div className="staff-registration__schedule__extend__way-of-work__left">
                                          <EllipseIcon />
                                          <span className="staff-registration__schedule__extend__way-of-work__span">
                                            총 근무 시간
                                          </span>
                                        </div>
                                      </div>
                                      <WorkingHoursLabel
                                        leftText={`주 ${formatNumberValueToKoreanTime(
                                          workTimeOfDay * schForm.workDaysOfWeek.length,
                                          // 추가된 일정의 요일 제거
                                          const unSelectedDayArr = daysOfWeekOptions.filter(i => {
                                            const selected = schList.map(j => {
                                              j.data.
                                            })
                                          })
                                        )} 근무`}
                                        rightText="적합한 설정입니다"
                                        icon="tick"
                                      />
                                    </>
                                  )} */}
                              </div>
                            )}

                            {/* Optional */}
                            {/* {workingMethod.optional && (
                            <div className="optional-form">
                              <div className="staff-registration__schedule__extend__way-of-work">
                                <div className="staff-registration__schedule__extend__way-of-work__left">
                                  <EllipseIcon />
                                  <span className="staff-registration__schedule__extend__way-of-work__span">
                                    반복기간
                                  </span>
                                </div>

                                <StartEndDate checkboxText="없음" setData={handleSetStartEndDate} />
                              </div>

                              <div className="staff-registration__schedule__extend__optional">
                                <div className="staff-registration__schedule__extend__optional__left">
                                  <EllipseIcon />
                                  <span className="staff-registration__schedule__extend__optional__span">반복일정</span>
                                </div>
                                <div className="staff-registration__schedule__extend__optional__content">
                                  <div className="staff-registration__schedule__extend__optional__row">
                                    <div className="staff-registration__schedule__extend__optional__left">
                                      <div>
                                        <CheckIcon />
                                      </div>
                                      <div className="staff-registration__schedule__extend__optional__text">
                                        근무 주
                                      </div>
                                      <div>
                                        <HelpCircleIcon />
                                      </div>
                                    </div>
                                    <div className="staff-registration__schedule__extend__optional__right">
                                      <Select
                                        className="staff-registration__schedule__body__input4"
                                        name="set-working-days"
                                        components={{
                                          IndicatorSeparator: () => null,
                                          DropdownIndicator: () => (
                                            <div
                                              style={{
                                                paddingRight: '15px',
                                              }}>
                                              <ArrowDownIcon />
                                            </div>
                                          ),
                                          SingleValue: () => (
                                            <div
                                              style={{
                                                paddingRight: '15px',
                                              }}>
                                              <ArrowDownIcon />
                                            </div>
                                          ),
                                        }}
                                        placeholder="템플릿 선택"
                                        styles={colourStyles}
                                        options={weeksOfMonth}
                                        onChange={setWeeksOfTheMonth}
                                        isMulti
                                        hideSelectedOptions={false}
                                        isClearable={false}
                                      />
                                    </div>
                                  </div>

                                  <div className="staff-registration__schedule__extend__optional__row">
                                    <div className="staff-registration__schedule__extend__optional__left">
                                      <div>
                                        <CheckIcon />
                                      </div>
                                      <div className="staff-registration__schedule__extend__optional__text">
                                        근무 요일
                                      </div>
                                    </div>
                                    <div className="staff-registration__schedule__extend__optional__right">
                                      <Select
                                        className="staff-registration__schedule__body__input4"
                                        name="set-working-days"
                                        components={{
                                          IndicatorSeparator: () => null,
                                          DropdownIndicator: () => (
                                            <div
                                              style={{
                                                paddingRight: '15px',
                                              }}>
                                              <ArrowDownIcon />
                                            </div>
                                          ),
                                          SingleValue: () => (
                                            <div
                                              style={{
                                                paddingRight: '15px',
                                              }}>
                                              <ArrowDownIcon />
                                            </div>
                                          ),
                                        }}
                                        placeholder="템플릿 선택"
                                        styles={colourStyles}
                                        options={daysOfWeek}
                                        onChange={setWorkingDays}
                                        isMulti
                                        hideSelectedOptions={false}
                                        isClearable={false}
                                      />
                                    </div>
                                  </div>

                                  <div className="staff-registration__schedule__extend__optional__row">
                                    <div className="staff-registration__schedule__extend__optional__left">
                                      <div>
                                        <CheckIcon />
                                      </div>
                                      <div className="staff-registration__schedule__extend__optional__text">
                                        근무 시간
                                      </div>
                                    </div>
                                    <div className="staff-registration__schedule__extend__optional__right">
                                      <TimePicker setData={setWorkingTime} />
                                      <div className="staff-registration__schedule__extend__way-of-work__rest-include">
                                        <Select
                                          className="staff-registration__schedule__body__input4"
                                          components={{
                                            IndicatorSeparator: () => null,
                                            DropdownIndicator: () => (
                                              <div
                                                style={{
                                                  paddingRight: '15px',
                                                }}>
                                                <ArrowDownIcon />
                                              </div>
                                            ),
                                          }}
                                          placeholder="템플릿 선택"
                                          styles={colourStyles}
                                          options={breakTimeArray}
                                          onChange={selectBreakTime}
                                        />
                                      </div>
                                    </div>
                                  </div>

                                  <div className="staff-registration__schedule__extend__optional__row">
                                    <div className="staff-registration__schedule__extend__optional__left"></div>
                                    <div className="staff-registration__schedule__extend__optional__right">
                                      <div className="staff-registration__schedule__extend__optional__button">
                                        <Button label="+ 반복 일정 추가" type="type3" />
                                      </div>
                                    </div>
                                  </div>
                                </div>
                                <div>
                                  {scheduledStaffRegData.map((item) => (
                                    <div className="staff-registration__schedule__extend__optional__recurring-schedule-card">
                                      <RecurringScheduleTaskCard data={item} />
                                    </div>
                                  ))}
                                </div>
                              </div>

                              <div className="staff-registration__schedule__extend__way-of-work">
                                <div className="staff-registration__schedule__extend__way-of-work__left">
                                  <EllipseIcon />
                                  <span className="staff-registration__schedule__extend__way-of-work__span">
                                    총 근무 시간
                                  </span>
                                </div>
                              </div>
                              <WorkingHoursLabel
                                leftText="주 평균 60시간"
                                rightText="적합하지 않은 설정입니다"
                                icon="info"
                              />
                            </div>
                          )} */}
                          </div>
                        )}
                      </div>
                    </div>
                  </div>
                </div>
                <div className="staff-registration__card__right">
                  <div className="staff-registration__schedule-right">
                    {/* <div>
                      <div className="staff-registration__schedule-right__head">일정템플릿이란?</div>
                      <div className="staff-registration__right-body">
                        직원 일정 정보를 템플릿으로 저장해두면 여러 명의 직원에게 일정 정보를 한꺼번에 적용할 수 있어요
                      </div>
                    </div> */}
                    <div>
                      <div className="staff-registration__schedule-right__head">일하는 방식</div>
                      <div className="staff-registration__right-body">
                        고정: 출퇴근 시간이 고정되어있어요
                        <br />
                        자율출퇴근 : 근무일정 없이 직원이 출퇴근을 기록해요
                      </div>
                    </div>
                    {schForm.workType === 'FIXED' && (
                      <div>
                        <div className="staff-registration__schedule-right__head">반복기간</div>
                        <div className="staff-registration__right-body">
                          반복기간의 종료일을 미정으로 선택하면 새로운 일정을 등록할 때까지 해당 일정으로 근무합니다.
                          합류 단계에서는 반복기간 날짜를 1종류만 설정해 주세요
                        </div>
                      </div>
                    )}
                  </div>
                </div>
              </div>
              {schList.length > 0 && (
                <div className="staff-registration__card">
                  <div className="staff-registration__card__left">
                    <div className="staff-registration__payment">
                      <div className="staff-registration__payment__head">추가할 일정</div>
                      <div className="staff-registration__payment__body">
                        <div className="staff-registration__list">
                          {schList.map((i, _i) => {
                            // 요일 배열
                            const dayArr: string[] = [];
                            i.data.map((j) => {
                              dayArr.push(getChangeToKorean(j.DAY));
                            });

                            return (
                              <div key={`schListItem_${i.start}_${i.end}${i.data[0].DAY}`} className="scheduleInfo">
                                <div className="section">
                                  <div className="label">일정기간</div>
                                  <div className="value">
                                    {moment(i.start).format('YYYY.MM.DD')}
                                    {i.end ? ' ~ ' + moment(i.end).format('YYYY.MM.DD') : ' ~ 계속'}
                                  </div>
                                  <div className="remove">
                                    <button onClick={() => removeSchListItem(_i)}>지우기</button>
                                  </div>
                                </div>
                                <WorkingDetailsCard
                                  days={dayArr.join(', ')}
                                  time={`${i.data[0].ATTENDANCE_TIME} ~ ${i.data[0].WORK_OFF_TIME}`}
                                  hours={formatNumberValueToKoreanTime(
                                    scheduleToMinValue(i.data[0].ATTENDANCE_TIME, i.data[0].WORK_OFF_TIME),
                                  ).toString()}
                                />
                              </div>
                            );
                          })}
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="staff-registration__card__right">
                    <div>
                      <div className="staff-registration__right-heads">추가할 일정</div>
                      <div className="staff-registration__right-body">
                        반복기간 동안 선택한 요일과 근무시간에 따라 출퇴근을 진행합니다
                      </div>
                    </div>
                  </div>
                </div>
              )}
            </div>
          )}
        </div>
        <CommonModal isVisible={employeeListModal} onClose={toggleEmployeeListModal} title="">
          <EmployeeListModal
            headerText="적용대상"
            subHeaderText="작성한 정보는 현재 선택된 직원 모두에게 적용됩니다"
            tableHeads={staffTableHeads}
            tableData={empList}
            showCompleteBtn={showCompleteBtn}
            onAction={() => {
              if (schForm.workType === 'FIXED') {
                updateEmpSchInfo();
              } else {
                setWorkType();
              }
            }}
          />
        </CommonModal>
      </PlainNavbar>
    </>
  );
};
export default StaffRegistration;
